import { useSelector } from "react-redux";
import type { RootState } from "../../store";
import {
  uploadOrbitSelectors,
  type UploadedOrbitsState,
} from "./index";

export const useUploadedOrbitsReadyStatusKey = () =>
  useSelector((state: RootState) =>
    uploadOrbitSelectors.getReadyUploadsStatusKey(
      state.uploadedOrbits as UploadedOrbitsState,
    ),
  );
